<template>
  <div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card v-can="'view-account-limit-request'" title="ACCOUNT LIMIT REQUEST">
          <template slot="actions" v-if="account_type === 'credit'">
            <vs-button v-can="'create-account-limit-request'"  @click="onClickCreateSite" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>
              <template slot="thead">
                <vs-th width="20%" sort-key="created_at">DATE</vs-th>
                <vs-th width="20%" sort-key="change_to">CREDIT AMOUNT REQUESTED ({{__accountCurrency()}})</vs-th>
                <vs-th width="30%" sort-key="reason_for_change">REASON FOR CHANGE</vs-th>
                <vs-th width="20%" sort-key="status">STATUS</vs-th>
                <vs-th width="10%" >ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td :data="data[indextr].change_to">
                    {{ data[indextr].change_to}}
                  </vs-td>

                  <vs-td :data="data[indextr].reason_for_change">
                    {{ data[indextr].reason_for_change}}
                  </vs-td>

                  <vs-td :data="data[indextr].status">
                    <vs-chip transparent :color="data[indextr].status === 'Approved' ? 'primary' : 'danger'">
                      {{ data[indextr].status }}
                    </vs-chip>
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip class="ml-2" text="View" position="left">
                        <vs-button @click.native="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>

    <create-customer-account-limit-request-pop-up ref="createCustomerAccountLimitRequestPopUp"/>
    <update-customer-account-limit-request-pop-up ref="updateCustomerAccountLimitRequestPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'
  import UpdateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/UpdateCustomerAccountLimitRequestPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        status_change_obj: {},
        activePrompt: false
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerAccountLimitRequestPopUp,
      UpdateCustomerAccountLimitRequestPopUp
    },
    props: {
      account_type: {
        default: 'credit'
      }
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getAccountLimitRequestList(this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup()
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerAccountLimitRequestPopUp.openPopup(id)
      },

      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
        }
      },
    },
    watch : {
      page(){
        this.loadStaff()
      }
    },
    computed: {
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
